<template>
  <div
    class="flex flex-col bg-gray-100 p-6 min-h-screen mt-0 sm:mt-0 md:mt-0 lg:mt-2 xl:mt-2"
  >
    <div>
      <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
        Zoekresultaten
      </p>
    </div>

    <div class="flex flex-row">
      <div class="self-end"></div>
      <div class="flex-grow"></div>
      <div class="mx-0 self-center">
        <button
          class="hidden sm:hidden md:hidden lg:block xl:block bg-gray-100 hover:text-gray-500 text-mi-blue-500 font-semibold h-10 px-4"
        >
          <i
            class="material-icons cursor-pointer md-3xl"
            @click="dynamicComponent = 'TableView'"
            v-if="dynamicComponent === 'CardView'"
            >view_list</i
          >
          <i
            class="material-icons cursor-pointer md-3xl"
            @click="dynamicComponent = 'CardView'"
            v-if="dynamicComponent === 'TableView'"
            >apps</i
          >
        </button>
      </div>
      <div>
        <button
          class="bg-gray-100 hover:bg-mi-blue-500 text-base text-mi-blue-500 font-semibold h10 hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
          @click="exportAccommodaties"
          v-if="hasPermission('export accommodaties')"
        >
          Exporteren
        </button>
        <button
          class="bg-gray-100 hover:bg-mi-blue-500 text-base text-mi-blue-500 font-semibold h10 hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
          @click="exportPublicAccommodaties"
          v-else
        >
          Exporteren
        </button>
      </div>
    </div>
    <div class="flex flex-row">
      <div class="flex-grow"></div>

      <div v-if="exportHit" class="text-red-600 float-right font-semibold">
        Uw downloadlink is verzonden naar {{ user.email }}
      </div>
    </div>
    <component :is="dynamicComponent"></component>
    <Pagination />
  </div>
</template>

<script>
import CardView from "./CardView";
import TableView from "./TableView";
import Pagination from "./Pagination";
import { mapState } from "vuex";
export default {
  name: "Accommodaties",

  data() {
    return {
      dynamicComponent: "CardView",
      exportHit: false
    };
  },
  computed: mapState({
    user: function() {
      return this.$store.getters.current_user;
    }
  }),
  methods: {
    exportAccommodaties: function() {
      this.$store.dispatch("exportAccommodaties", {
        organisation: "",
        reason: ""
      });
      this.exportHit = true;
    },
    exportPublicAccommodaties: function() {
      this.$router.push({ name: "PublicExport" });
    },
    hideExportMessage: function() {
      this.exportHit = false;
    }
  },
  watch: {
    exportHit(newValue) {
      if (newValue === true) {
        setTimeout(this.hideExportMessage, 5000);
      }
    }
  },

  components: {
    CardView,
    TableView,
    Pagination
  }
};
</script>
